export const EXHIBITION_STOCK_SEARCH_INTERVAL = 500;
export const EXHIBITION_IMAGE_MAXIMUM_SIZE = 1500000;
export const EXHIBITION_IMAGE_MINIMUM_SIZE = 1;
